import styled, { css } from 'styled-components'

export const Container =  styled.div`
display:flex;
flex-direction:column;
gap:32px;
width:100%;
`